import classNames from 'classnames';
import React from 'react';
import styles from './KeywordsBroadMatchTable.module.css';

type Props = {
  broadMatch: {
    matchType: string;
    broad: React.ReactNode;
    phrase: React.ReactNode;
    exact: string;
  }[];
  labels: {
    matchType: string;
    broad: string;
    default: string;
    phrase: string;
    quotes: string;
    exact: string;
    brackets: string;
  };
  isMM?: boolean;
};

export const KeywordsBroadMatchTable = (props: Props) => {
  const { broadMatch, labels, isMM } = props;

  return (
    <div
      className={classNames(styles.broadMatchTable, {
        [styles.broadMatchTableMM]: isMM,
      })}
    >
      <div className={styles.broadMatchTableLabelsRow}>
        <div
          className={classNames(
            styles.benefitsTableColumn,
            styles.matchTypeColumn,
          )}
        >
          {labels.matchType}
        </div>
        <div className={styles.benefitsTableColumn}>
          <div>
            {labels.broad}
            <span className={styles.matchTypeColumn}> - </span>
          </div>
          <div className={styles.matchTypeColumn}>{labels.default}</div>
        </div>
        <div className={styles.benefitsTableColumn}>
          <div>
            {labels.phrase}
            <span className={styles.matchTypeColumn}> - </span>
          </div>
          <div className={styles.matchTypeColumn}>
            &quot;{labels.quotes}&quot;
          </div>
        </div>
        <div className={styles.benefitsTableColumn}>
          <div>
            {labels.exact}
            <span className={styles.matchTypeColumn}> - </span>
          </div>
          <div className={styles.matchTypeColumn}>[{labels.brackets}]</div>
        </div>
      </div>
      {broadMatch.map(item => (
        <div key={item.matchType} className={styles.broadMatchTableRow}>
          <div
            className={classNames(
              styles.matchTypeColumn,
              styles.benefitsTableColumn,
            )}
          >
            <div className={styles.benefitLink}>{item.matchType}</div>
          </div>
          <div className={styles.benefitsTableColumn}>
            <div className={styles.benefitLink}>{item.broad}</div>
          </div>
          <div className={styles.benefitsTableColumn}>
            <div className={styles.benefitLink}>{item.phrase}</div>
          </div>
          <div className={styles.benefitsTableColumn}>
            <div className={styles.benefitLink}>{item.exact}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
